import React from 'react';

interface BlogAuthorBioProps {
  authorName: string;
  authorRole?: string | null;
  authorBio?: string | null;
  onOpenQuestionModal: () => void;
  onBack?: () => void;
}

export const BlogAuthorBio: React.FC<BlogAuthorBioProps> = ({
  authorName,
  authorRole,
  authorBio,
  onOpenQuestionModal,
  onBack,
}) => {
  return (
    <div className="mt-16 p-10 rounded-[2.5rem] bg-slate-50 border border-slate-100 flex flex-col sm:flex-row gap-8 relative overflow-hidden group text-left">
      <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/5 blur-3xl rounded-full translate-x-1/2 -translate-y-1/2 group-hover:scale-150 transition-transform duration-700" />

      <div className="w-24 h-24 rounded-3xl bg-indigo-600 text-white font-bold text-3xl flex items-center justify-center shrink-0 shadow-xl shadow-indigo-200 ring-4 ring-white">
        {authorName.charAt(0).toUpperCase()}
      </div>
      <div className="space-y-4 relative z-10">
        <div>
          <p className="text-xl font-black text-slate-900">{authorName}</p>
          <p className="text-[10px] font-black text-indigo-600 uppercase tracking-[0.2em] mt-1">
            {authorRole || 'Editor & Kontributor Konten UIBN'}
          </p>
        </div>
        <p className="text-sm text-slate-600 leading-relaxed font-medium">
          {authorBio ||
            'Kontributor konten UIBN yang fokus dalam memberikan panduan teknis mengenai standar penulisan buku dan regulasi penerbitan di Indonesia.'}
        </p>
        <div className="flex gap-6 pt-2">
          <button
            type="button"
            onClick={onOpenQuestionModal}
            className="text-[10px] font-black text-slate-400 hover:text-indigo-600 transition-colors uppercase tracking-widest flex items-center gap-2 group/btn cursor-pointer"
          >
            Tanya Penulis
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </button>
          <button
            type="button"
            onClick={() => {
              if (onBack) {
                onBack();
              } else {
                window.history.pushState({}, '', '/blog');
                window.dispatchEvent(new PopStateEvent('popstate'));
              }
            }}
            className="text-[10px] font-black text-slate-400 hover:text-indigo-600 transition-colors uppercase tracking-widest flex items-center gap-2 group/btn cursor-pointer"
          >
            Semua Artikel
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};
